import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Popover, PopoverBackdrop, PopoverContent, PopoverArrow, PopoverHeader, PopoverCloseButton, PopoverBody, PopoverFooter } from "@/components/ui/popover";
import { HStack } from "@/components/ui/hstack";
import { Divider } from "@/components/ui/divider";
import { Button } from "@/components/ui/button";
import { View } from "@/components/ui/view";
import React, { useState } from 'react';
import { useEdges, useNodes } from "reactflow";
import { FlatList } from "react-native";
import i18n from "i18n-js";
import IssueIntensity from "../../algorithms_and_functions/validation/IssueIntensity";
import HighLightIssueButton from "./HighLightIssueButton";
import validation from "../../algorithms_and_functions/validation/validation";
import ExportButton from "./ExportButton";
import { IconMC } from '@/components/media/IconsV2';
import SimulatorButton from "./SimulatorButton";
import { useSelector } from 'react-redux';

export default function ValidationPopover({ fitView, save, flowId, allIssues, setAllIssues, onOpenSimulator }) {

    const internal = useSelector((state) => state.settings.preview)
    const nodes = useNodes()
    const edges = useEdges()

    const [isOpen, setIsOpen] = useState(false)
    const [isValid, setIsValid] = useState(true)

    const openAndFocusSimulator = () => {
        setIsOpen(false)
        requestAnimationFrame(onOpenSimulator)
    }

    const openPopover = () => {
        console.log('press validation')
        const result = validation(nodes, edges)
        let valid = true

        for (const issue of result) {
            if (issue.intensity === IssueIntensity.Error) {
                valid = false
                break
            }
        }

        setIsValid(valid)
        setAllIssues(result)
        setIsOpen(true)
    }

    const sortIssues = (a, b) => {
        if (a.intensity === IssueIntensity.Error && b.intensity === IssueIntensity.Info) {
            return -1
        } else if (a.intensity === IssueIntensity.Info && b.intensity === IssueIntensity.Error) {
            return 1
        } else {
            return 0
        }
    }

    return (
        <Popover trigger={(triggerProps) => {
            return (
                <Button {...triggerProps} onPress={() => openPopover()} className="h-[34px] bg-primary-900">
                    <HStack space='xs' className="items-center">
                        <IconMC className='text-secondary-50' name='checkbox-marked-circle-outline' />
                        <Text className="text-secondary-50">{i18n.t('studio.flow.validation')}</Text>
                    </HStack>
                </Button>
            );
        }} isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <PopoverBackdrop/>
            <PopoverContent>
                <PopoverArrow/>
                <PopoverHeader>
                    <Text className={`${isValid ? "text-secondary.900" : "text-error-600"} font-bold `}>{i18n.t(isValid ? 'studio.issue.workflowValid' : 'studio.issue.workflowInvalid')}</Text>
                    <PopoverCloseButton onPress={() => setIsOpen(false)}>
                        <View className='bg-primary-50 border-2 border-primary-900 rounded-[4px] p-1 w-fit self-end'>
                            <IconMC className='text-primary-900' size={24} name='close' />
                        </View>
                    </PopoverCloseButton>
                </PopoverHeader>
                <PopoverBody>
                    <VStack className="w-[400px]">
                        <FlatList
                            data={allIssues.sort((a, b) => sortIssues(a, b))}
                            ItemSeparatorComponent={() => <Divider />}
                            renderItem={({ item, index }) => {
                                return <HighLightIssueButton issue={item} index={index} fitView={fitView} />;
                            }} />
                    </VStack>
                </PopoverBody>
                <PopoverFooter className="justify-center items-center gap-6 p-3">
                    {internal && <SimulatorButton valid={isValid} onOpenSimulator={openAndFocusSimulator} />}
                    <ExportButton save={save} flowId={flowId} valid={isValid} setIsOpen={setIsOpen} />
                </PopoverFooter>
            </PopoverContent>
        </Popover>
    );
}
